module.exports = __webpack_public_path__ + "img/re.10c5bee3.svg";